import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Scrolls the window to the top every time the route (pathname) changes —
// e.g. clicking any Header link (Home / About / Products / Contact / Services).
// Skips the scroll for in-page hash links like /products#some-category so
// those can still jump to their section instead of the very top.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (hash) return; // let hash links (e.g. #electrical-conductors) do their own scrolling
    // 'POP' = browser back/forward — let the browser restore its own scroll position
    if (navType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash, navType]);

  return null;
}
